"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSwipers = initSwipers;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
const utils_1 = require("./utils");
function initSwipers() {
    // Hero Swiper
    const heroSwiperEl = document.querySelector('.mySwiper');
    if ((0, utils_1.guardElement)(heroSwiperEl, 'Hero swiper not found')) {
        new swiper_1.default('.mySwiper', {
            modules: [modules_1.Navigation, modules_1.Pagination, modules_1.Autoplay],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 700,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 9000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        });
    }
    // Gallery Swiper
    const gallerySwiperEl = document.querySelector('.gallery-swiper__swiper');
    if ((0, utils_1.guardElement)(gallerySwiperEl, 'Gallery swiper not found')) {
        new swiper_1.default('.gallery-swiper__swiper', {
            speed: 500,
            slidesPerView: 1.07,
            spaceBetween: 14,
            loop: true,
            breakpoints: {
                601: { slidesPerView: 1.17, spaceBetween: 14 },
                720: { slidesPerView: 1.3, spaceBetween: 16 },
                920: { slidesPerView: 1.5, spaceBetween: 20 },
                1280: { slidesPerView: 1.7, spaceBetween: 30 },
                1600: { slidesPerView: 1.85, spaceBetween: 48 },
                2560: { slidesPerView: 1.9, spaceBetween: 80 },
            },
        });
    }
    // Image Gallery Slider
    const imgGallerySwiperEl = document.querySelector('.img-gallery-slider__swiper');
    if ((0, utils_1.guardElement)(imgGallerySwiperEl, 'Image gallery swiper not found')) {
        new swiper_1.default('.img-gallery-slider__swiper', {
            modules: [modules_1.Navigation],
            speed: 500,
            slidesPerView: 1.04,
            spaceBetween: 12,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                601: { slidesPerView: 1.12, spaceBetween: 16 },
                720: { slidesPerView: 1.5, spaceBetween: 24 },
                920: { slidesPerView: 2.08, spaceBetween: 24 },
                1280: { slidesPerView: 2.08, spaceBetween: 38 },
                2560: { slidesPerView: 2.5, spaceBetween: 64 },
                3680: { slidesPerView: 3, spaceBetween: 80 },
            },
        });
    }
    // Testimonial Swiper
    const testimonialSwiperEl = document.querySelector('.testimonials__swiper');
    if ((0, utils_1.guardElement)(testimonialSwiperEl, 'Testimonial swiper not found')) {
        new swiper_1.default('.testimonials__swiper', {
            modules: [modules_1.Navigation, modules_1.Pagination],
            slidesPerView: 1,
            loop: true,
            spaceBetween: 16,
            breakpoints: {
                700: { slidesPerView: 2, spaceBetween: 16 },
                1280: { slidesPerView: 3, spaceBetween: 24 },
                2560: { slidesPerView: 3.5, spaceBetween: 64 },
            },
            pagination: {
                el: '.testimonials__swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}
